import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  vi_VN: {
    translation: {
      "Label.Required": "Hoàn thành trường này",
      "Label.RequiredLogin": "Vui lòng đăng nhập để gửi đánh giá",
      "Label.DataInvalid": "Dữ liệu không hợp lệ",

      "Label.VeryBad": "Rất tệ",
      "Label.Bad": "Tệ",
      "Label.Normal": "Bình thường",
      "Label.Good": "Tốt",
      "Label.VeryGood": "Rất tốt",

      "Label.GoodProductQuality": "Chất lượng sản phẩm tuyệt vời",
      "Label.GoodProductPack": "Đóng gói sản phẩm rất đẹp và chắc chắn",
      "Label.GoodStoreService": "Shop phục vụ rất tốt",
      "Label.GoodWorthMoney": "Rất đáng tiền",
      "Label.GoodDeliveryTime": "Thời gian giao hàng rất nhanh",

      "Label.ReviewsTitle": "Đánh giá, hỏi đáp về sản phẩm",
      "Label.Reviews": "Đánh giá",
      "Label.WriteReviews": "Viết đánh giá",
      "Label.QA": "Hỏi đáp",
      "Label.WriteQuestion": "Đặt câu hỏi",
      "Label.Rating": "Xếp hạng",
      "Label.SendReviews": "Gửi ngay",
      "Label.SuccessMessageReviews": "Cảm ơn bạn đã gửi đánh giá!",

      "Label.Title": "Tiêu đề",
      "Label.Content": "Nội dung",
      "Label.FullName": "Họ tên",
      "Label.Email": "Email",
      "Label.Phone": "Số điện thoại",

      "Label.All": "Tất cả",
      "Label.Purchased": "Đã mua hàng",
      "Label.Image": "Hình ảnh",
      "Label.ImageSelect": "Chọn ảnh",
      "Label.ImageSizeBig": "Kích thước file quá lớn",
      "Label.ImageTypeNotSupport": "File không được hỗ trợ",
      "Label.ImageHelper":
        "Kích thước tối đa: 5MB, định dạng: jpg | jpeg | gif | png",
    },
  },
  en_US: {
    translation: {
      "Label.Required": "Complete this field",
      "Label.RequiredLogin": "Please log in to submit a review",
      "Label.DataInvalid": "Invalid data",

      "Label.VeryBad": "Very bad",
      "Label.Bad": "Bad",
      "Label.Normal": "Normal",
      "Label.Good": "Good",
      "Label.VeryGood": "Very good",

      "Label.GoodProductQuality": "Excellent product quality",
      "Label.GoodProductPack": "Product packaging is very nice and secure",
      "Label.GoodStoreService": "The store has very good service",
      "Label.GoodWorthMoney": "Very worth the money",
      "Label.GoodDeliveryTime": "Very fast delivery time",

      "Label.ReviewsTitle": "Reviews, Q&A about products",
      "Label.Reviews": "Reviews",
      "Label.WriteReviews": "Write reviews",
      "Label.QA": "Q&A",
      "Label.WriteQuestion": "Write question",
      "Label.Rating": "Rating",
      "Label.SendReviews": "Send now",
      "Label.SuccessMessageReviews": "Thank you for submitting a review!",

      "Label.Title": "Title",
      "Label.Content": "Content",
      "Label.FullName": "Full name",
      "Label.Email": "Email",
      "Label.Phone": "Phone",

      "Label.All": "All",
      "Label.Purchased": "Purchased",
      "Label.Image": "Image",
      "Label.ImageSelect": "Select image",
      "Label.ImageSizeBig": "File size is too big",
      "Label.ImageTypeNotSupport": "Unsupported files",
      "Label.ImageHelper":
        "Maximum size: 5MB, file type: jpg | jpeg | gif | png",
    },
  },
  ko_KR: {
    translation: {
      "Label.Required": "해당 항목을 작성해 주세요.",
      "Label.DataInvalid": "유효하지 않은 데이터입니다.",

      "Label.VeryBad": "별로예요",
      "Label.Bad": "그냥 그래요",
      "Label.Normal": "보통이에요",
      "Label.Good": "마음에 들어요",
      "Label.VeryGood": "아주 좋아요",

      "Label.GoodProductQuality": "품질이 우수해요",
      "Label.GoodProductPack": "포장이 예쁘고 든든해요",
      "Label.GoodStoreService": "쇼핑몰 서비스가 최고예요",
      "Label.GoodWorthMoney": "값어치가 좋아요",
      "Label.GoodDeliveryTime": "배송이 빨라요",
      
      "Label.Reviews": "제품에 대한 리뷰, Q&A",
      "Label.Reviews": "리뷰",
      "Label.WriteReviews": "리뷰 작성",
      "Label.QA": "Q & A",
      "Label.WriteQuestion": "질문 쓰기",
      "Label.Rating": "등급",
      "Label.SendReviews": "리뷰 등록",
      "Label.SuccessMessageReviews": "리뷰를 작성해 주셔서 감사합니다!",

      "Label.Title": "제목",
      "Label.Content": "내용",
      "Label.FullName": "작성자명",
      "Label.Email": "이메일",
      "Label.Phone": "연락처",

      "Label.All": "전체",
      "Label.Purchased": "구매한 상품",
      "Label.Image": "영상",
      "Label.ImageSelect": "이미지 선택",
      "Label.ImageSizeBig": "선택하신 이미지 사이즈가 초과되었습니다.",
      "Label.ImageTypeNotSupport": "지원되지 않는 파일 형식입니다.",
      "Label.ImageHelper": "최대 용량: 5MB, 파일 형식: jpg | jpeg | gif | png",
    },
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "vi_VN", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
